const ITEMS = [
    "Progettazione Grafica",
    "Stampa Tipografica",
    "Carte da Parati",
    "Allestimenti",
    "Gadget & Merchandising",
    "Personalizzazioni su Misura",
];

const Mark = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true" className="shrink-0">
        <rect x="2" y="2" width="9" height="9" fill="#0099FF" />
        <rect x="13" y="2" width="9" height="9" fill="#FF0066" />
        <rect x="2" y="13" width="9" height="9" fill="#FFCC00" />
        <rect x="13" y="13" width="9" height="9" fill="#FAF8F5" />
    </svg>
);

export const Marquee = () => (
    <div data-testid="editorial-marquee" aria-hidden="true" className="bg-[#0E0E10] text-[#FAF8F5] py-5 sm:py-6 overflow-hidden border-y border-zinc-800">
        <div className="marquee-track">
            {[0, 1].map((copy) => (
                <div key={copy} className="flex items-center shrink-0">
                    {ITEMS.map((item) => (
                        <span key={item} className="flex items-center">
                            <span className="font-heading text-2xl sm:text-3xl font-bold tracking-tight px-8 sm:px-10 whitespace-nowrap">
                                {item}
                            </span>
                            <Mark />
                        </span>
                    ))}
                </div>
            ))}
        </div>
    </div>
);
